export const environment = {
  production: true,
  // url: "https://localhost:44312/api",
  url: "https://enviodocumentos.wicpr.net/InternshipProgramApi/api",
};
